import * as React from 'react';
import classNames from 'classnames';
import { ThemeContext } from 'app-themes';
import { Spin } from 'components/antd';
import AntAutocomplete, {
	DataSourceItemObject,
	AutoCompleteProps as AntAutocompleteProps,
} from 'antd/lib/auto-complete';

import { OptionProps, OptGroupProps } from 'antd/lib/select';

import styles from './Autocomplete.module.scss';
export interface AutocompleteProps extends AntAutocompleteProps {
	isValid?: boolean;
	isLoading?: boolean;
}

interface AutocompleteState {
	open: boolean;
	innerDataSource?: DataSourceItemObject[];
}

export class Autocomplete extends React.Component<AutocompleteProps, AutocompleteState> {
	static contextType = ThemeContext;
	static Option: React.ClassicComponentClass<OptionProps>;
	static OptGroup: React.ClassicComponentClass<OptGroupProps>;
	inputRef = React.createRef<AntAutocomplete>();

	blur = (value?: string) => {
		const { current } = this.inputRef;
		if (current) {
			current.blur();
		}
		if (this.props.onBlur) {
			this.props.onBlur(value || '');
		}
	};

	render() {
		const { isValid, className, isLoading, ...restProps } = this.props;
		const theme = this.context;
		return (
			<Spin
				spinning={Boolean(isLoading)}
				blurOff={true}
				className={classNames(styles.spin, { [styles.spinOnError]: isValid === false })}
			>
				<AntAutocomplete
					ref={this.inputRef}
					className={classNames(className, styles.autocomplete, {
						[styles.autocompleteError]: isValid === false,
						[styles[`autocomplete-${theme}`]]: theme !== '',
					})}
					dropdownClassName={styles.autocompleteDropdown}
					{...restProps}
				/>
			</Spin>
		);
	}
}

Autocomplete.Option = AntAutocomplete.Option;
Autocomplete.OptGroup = AntAutocomplete.OptGroup;

export default Autocomplete;
